import { StyleSheet } from '@patternfly/react-styles';
export default StyleSheet.parse(`.pf-c-avatar{--pf-c-avatar--BorderRadius:var(--pf-global--BorderRadius--lg);--pf-c-avatar--Width:2.25rem;--pf-c-avatar--Height:2.25rem;width:var(--pf-c-avatar--Width);height:var(--pf-c-avatar--Height);border-radius:var(--pf-c-avatar--BorderRadius);}`);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/@patternfly/patternfly-next/components/Avatar/avatar.css.js
// module id = 212
// module chunks = 0